<template>
    <div class="list-wrapper folders-list search-list" v-if="contacts_list.count">
        <SmartList ref="smart_list_component"
          @smartListItemsSet=onSmartListItemsSet
          :smart_list_items="contacts_list.items"
        >
            <template #elements>
                <div v-for='contact in smart_list_items'
                :key="contact.id"
                class="contact"
                tabindex="0"
                :class="{'active' : contacts_selection.index[contact.id]}"
                @click="onContactSelect(contact)"
                >
                    <div class="radio-button">
                        <input :id="'atrbg_'  + contact.id" type="radio" @click.prevent.stop="null" :checked=" contacts_selection.index[contact.id]" tabindex="-1">
                        <label :for="'atrbg_' + contact.id" tabindex="-1"></label>
                    </div>
                    <div tabindex="-1">
                        <span class="name">{{contact.name}}</span>
                    </div>
                </div>
            </template>
        </SmartList>
    </div>

    <ContentEmpty v-else
        text='contacts.list.empty_results'
    />
</template>

<script setup>
  import {ref, defineExpose, defineProps, defineEmits} from 'vue';
  import SmartList                                     from '@/vue/Elements/Tools/SmartList.vue';
  import ContentEmpty                                  from '@/vue/Elements/Content/ContentEmpty.vue';

  const props = defineProps({
    contacts_list     : {},
    contacts_selection: {}
  })

  const smart_list_component = ref();
  const smart_list_items     = ref();

  const emit = defineEmits([
    'contactSelect'
  ])

  const onSmartListItemsSet = (items) => {
    setSmartListItems(items);
  }

  const onContactSelect = (contact) => {
    (props.contacts_selection.exists(contact.id))
      ? props.contacts_selection.reset()
      : props.contacts_selection.unique(contact);

    emit('contactSelect', contact);
  }

  const setSmartListItems = (items) => {
    smart_list_items.value = items;
  }

  const scrollToContact = (contact) => {
    if (!props.contacts_list.count) {
      return;
    }

    smart_list_component.value.scrollToItem(contact);
  }

  defineExpose({
    scrollToContact: scrollToContact,
  })

</script>
